import { Component, OnInit, Input, ElementRef, AfterViewInit } from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-generic-panel',
  templateUrl: './generic-panel.component.html',
  styleUrls: ['./generic-panel.component.scss'],
})
export class GenericPanelComponent implements AfterViewInit, OnInit {

  @Input() public icon: string;
  @Input() public awesomeIcon: string;
  @Input() public title: string;
  @Input() public description: string;
  @Input() public tooltipText: string;
  @Input() public isAnimate: boolean;

  animationClass = 'card-animate card-hidden';

  constructor(private _elementRef: ElementRef) {
  }

  ngAfterViewInit(): void {


    if (this.isAnimate) {

      setTimeout(function() {
         const htmlTag = this._elementRef.nativeElement.querySelector(
           '.card-hidden'
         );

         htmlTag.classList.remove('card-hidden');
      }.bind(this), 500);

    }
  }

  ngOnInit(): void {
     if (!this.isAnimate) {
       this.animationClass = '';
     }

  }
}
